import {
  FETCH_WEATHER_STATION_DATASTREAM_LIST_FAILURE,
  FETCH_WEATHER_STATION_DATASTREAM_LIST_REQUEST,
  FETCH_WEATHER_STATION_DATASTREAM_LIST_SUCCESS,
} from "../actions/weatherStationDatastreamsList.actions";

const initialState = {
  data: [],
  loading: false,
};

const weatherStationDatastreamList = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WEATHER_STATION_DATASTREAM_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_WEATHER_STATION_DATASTREAM_LIST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case FETCH_WEATHER_STATION_DATASTREAM_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default weatherStationDatastreamList;
